export const getImagesSortValue = (sortValue) => 
{
    if (!sortValue) return {};
    const [sortBy, order] = sortValue.split("_");
    return {
        sortBy: sortBy?.toLowerCase(),
        order: order?.toLowerCase(),
    };
};